const days = 8;
export default days;
export const amountOfcardsFetched = 8;
export const adminProtocolName = "overWatchProtocol";
export const adminProtocolStorage = "overWatch";
export const tierStorage = "tier";
export const inviteQuery = "invtID";
export const rewardfulReferral = "rewardfulReferral";
